<script>
import NavBar from './NavBar.svelte';
import Notifications from './Notifications.svelte';
import FirstTimeLogin from './FirstTimeLogin.svelte';
import { user, NavLinks } from './store.js';
import { Link, useNavigate, useLocation } from "svelte-navigator";
import { ShowName } from './theme';

const navigate = useNavigate();
const location = useLocation();

// TODO temp - this logic should be external to the layout
let frame;
$: frame = true; //!['/floor', '/partners', '/'].includes($location.pathname)
// export let frame = true;

let self;
let showMenu;
let showMobileMenu = false;

const logout = () => {
  $user = undefined;
  navigate('/');
}

let height;
$: height = window.innerHeight;
</script>

<div class="header row">
  <div class="row vcenter between f1">
    <Link to="/">
      <div class="row vcenter pointer" on:click={() => navigate('/')}>
        <div class="logo-box logo-box-mobile">
          <div class="logo logo-mobile-small" />
        </div>
        <div class="name">{ShowName}</div>
      </div>
    </Link>

    <div class="desktop-right row vcenter pointer">
      <!-- <div class="menu-base row vcenter mr-16" on:mouseenter={() => showMenu = true}>
        <div>{$user?.name}</div>
        <span class="material-icons">expand_more</span>

        <div class="profile-menu" class:show={showMenu} on:mouseleave={() => showMenu = false}>
          <div class="menu col">
            <div class='menuitem' on:click={logout}>Sign Out</div>
          </div>
        </div>
      </div> -->

      <Link to="/help">
        <img src="/img/help-icon.svg">
      </Link>
    </div>

    <div class="mobile-right">
      <div class="material-button" on:click={() => showMobileMenu = !showMobileMenu}>
        <span class="material-icons">menu</span>
      </div>
    </div>

    <div class="mobile-menu" class:show={showMobileMenu} on:click={() => showMobileMenu = false}>
      <div class="content col">
        {#each NavLinks as link}
          <Link to={link.to}>
            <div class="item" class:active={$location.pathname === link.to}>
              {#if link.icon[0] === '/'}
                <img src={link.icon} class="image-icon" />
              {:else}
                <span class="material-icons">{link.icon}</span>
              {/if}
              {link.name}
            </div>
          </Link>
        {/each}
        <div class="hr" />
        <Link to="/help"><div class="item-sub">Help Desk</div></Link>
        <div class="item-sub" on:click={logout}>Sign Out</div>
        <a href="" target="_blank"><div class="item-sub">Terms of Use</div></a>
      </div>
    </div>
  </div>
</div>

<Notifications />

<FirstTimeLogin />

<NavBar />

<div bind:this={self} class="col frame-content" class:frame>
  <slot />
</div>

<style lang="scss">
@import './util';
@import './theme';

$headerHeight: 5rem;
.header {
  position: fixed;
  height: $headerHeight;
  right: 0;
  left: 0;
  top: 0;
  z-index: 1000;
  padding: 0 5rem 0 10.5rem;
  background-color: $topbar-background-color;
  color: $topbar-foreground-color;

  @include tablet {
    padding: 0 16px;
  }
}

.image-icon {
  margin-right: 12px;
  // Computed via: https://codepen.io/sosuke/pen/Pjoqqp
  // TODO cleaner method (remove duplication with NavBar)
  filter: brightness(0) saturate(100%) invert(14%) sepia(68%) saturate(0%) hue-rotate(184deg) brightness(96%) contrast(86%);
}

.item.active .image-icon {
  filter: brightness(100);
}

.logo-mobile-small {
  @include landscape {
    background-image: url('/img/logo-sm.png');
    width: 72px;
  }
}

.logo-box-mobile {
  @include landscape {
    padding-right: 12px;
  }
}

.desktop-right {
  @include mobile {
    display: none;
  }
}

.mobile-right {
  display: none;

  @include mobile {
    display: block;
  }
}
.menu-base {
  position: relative;
}

.frame-content {
  margin-left: 5rem;
  margin-top: $headerHeight;
  color: var(--gray5);

  &.frame {
    padding: 2rem 5rem 2rem 5.5rem;

    @include landscape {
      padding: 16px;
    }
  }

  @include mobile {
    margin-left: 0;
  }
}

.name {
  margin-left: 32px;
  font-weight: 350;
  font-size: 24px;

  @include landscape {
    margin-left: 24px;
  }
}

.menuitem {
  padding: 8px 24px;
  white-space: nowrap;
  color: var(--gray5);
  margin: 1px;
  border-radius: 0 0 5px 5px;

  &:hover {
    // background-color: #330000;
  }
}
.profile-menu {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  display: none;

  .menu {
    margin-top: 2rem;
    background-color: white;
    border-radius: 0 0 5px 5px;
  }
}

.mobile-menu {
  position: absolute;
  z-index: 2;
  top: 5rem;
  left: 0;
  right: 0;
  height: 100vh;
  background-color: rgba(0,0,0,.7);
  display: none;
  .content {
    background-color: white;
    padding-bottom: 18px;
    
    .hr {
      margin: 0 18px;
      height: 1px;
      background-color: var(--gray5);
      opacity: .2;
    }

    .item {
      cursor: pointer;
      padding: 18px 34px;
      font-weight: bold;
      display: flex;
      align-items: center;
      color: black;
  
      span {
        margin-right: 12px;
      }
    }
  
    .item.active {
      background-color: var(--gray5);
      color: white;
    }
  
    .item-sub {
      padding: 18px 34px;
      cursor: pointer;
      display: flex;
      color: black;
    }
  }
}

.show {
  display: block;
}
</style>